import { Reducer } from "redux";

import { PostPutPatientRequestResponse } from "../models/Api/AllPatientRecord";
import { PatientRequestActionDispatchTypes } from "../constants/AllPatientRecord";
import { PatientRequestDispatchTypes } from "../models/DispatchTypes/AllPatientRecord";

const initialState: PostPutPatientRequestResponse = {
  loading: false,
  response: {
    referralDetail: {
      referralId: 0,
      patientId: 0,
      receivedDateTime: "",
      userSpecificReceivedDateTime: "",
      urgencyId: null,
      receivedMethodId: null,
      receivedMethodName: null,
      isSignedHealthOrder: "",
      signedOrderDate: null,
      signedOrderType: "",
      orderedById: null,
      acceptedById: null,
      isCustodialCare: "",
      isNonCoveredService: "",
      userCreated: null,
      nonCoveredServices: null,
      healthProgramId: null,
      careProgramId: null,
      urgencyStatus: "",
      orderedByName: "",
      acceptedByName: "",
      nonCoveredServiceNames: "",
      patientEligibilityId: 0,
      authorizationTypeId: 0,
      authorizationTypeName: ""
    },
    emergencyContact: [],
    residentialAddress: {
      streetName1: null,
      streetName2: null,
      county: null,
      city: null,
      patientState: null,
      zipCode: null,
      latitude: null,
      longitude: null,
      streetName: null,
      addressTypeId: null,
    },
    serviceAddress: {
      streetName1: null,
      streetName2: null,
      county: null,
      city: null,
      patientState: null,
      zipCode: null,
      latitude: null,
      longitude: null,
      streetName: null,
      addressTypeId: null,
    },
    requester: {
      facilityTypeId: null,
      requesterName: "",
      requesterExtension: "",
      requesterPhoneNo: "",
      requesterEmail: null,
      requesterFax: "",
      streetName1: null,
      streetName2: null,
      county: null,
      city: null,
      requesterState: null,
      zipCode: null,
      facilityTypeName: "",
      facilityName: "",
      requesterNpi: null,
    },
    referralSource: {
      facilityTypeId: null,
      referralSourceName: "",
      referralSourceExtension: "",
      referralSourcePhoneNo: "",
      referralSourceEmail: null,
      referralSourceFax: null,
      streetName1: null,
      streetName2: null,
      county: null,
      city: null,
      referralSourceState: null,
      zipCode: null,
      sameAsRequestingFacility: false,
      dischargeDate: null,
      facilityTypeName: "",
      facilityName: "",
      referralSourceNpi: null,
    },
    isSameAsResidential: false,
  },
  error: null,
};

const SaveOrUpdatePatientReferralRequest: Reducer<
  PostPutPatientRequestResponse,
  PatientRequestDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case PatientRequestActionDispatchTypes.POST_PUT_PATIENT_REQUEST_INVOKE: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case PatientRequestActionDispatchTypes.POST_PUT_PATIENT_REQUEST_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
        error: {},
      };
    }
    case PatientRequestActionDispatchTypes.POST_PUT_PATIENT_REQUEST_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.response,
      };
    }
    case PatientRequestActionDispatchTypes.POST_PUT_PATIENT_REQUEST_RESET: {
      return initialState;
    }
  }
  return state;
};

export default SaveOrUpdatePatientReferralRequest;
